import { render, staticRenderFns } from "./btnsx3.vue?vue&type=template&id=4b573f78&scoped=true&"
import script from "./btnsx3.vue?vue&type=script&lang=js&"
export * from "./btnsx3.vue?vue&type=script&lang=js&"
import style0 from "./btnsx3.vue?vue&type=style&index=0&id=4b573f78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b573f78",
  null
  
)

export default component.exports